import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FiCheck, FiAlertTriangle } from 'react-icons/fi';

import { initializePaddle } from '@paddle/paddle-js';
import { useEffect } from "react";
import { useState, useRef } from 'react';
import { useAuth } from '../lib/StAuthGiver.js';
import { callApi } from '../lib/Common_funcs.js';
import { CurPricing } from '../lib/Prices.js';

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined ? 'aws' : 'staging');
const Tdebug = (WhichEnv != 'aws');

export const StSubscription = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const { loginAction, logOut } = useAuth();
    const [error, setError] = useState('');
    const [subReceived, setSubReceived] = useState('');
    const [allPlans, setAllPlans] = useState({});
    const [pc, setPc] = useState('');
    const [TurboPaddleInstance, setTurboPaddleInstance] = useState(null);
    const [showModal, setModalShow] = useState(false)
    const [tenure, setTenure] = useState('monthly');
    const [planTerm, setPlanTerm] = useState('');

    const CheckoutProcessing = 1;
    const CheckoutSuccess = 2;
    const CheckoutFailed = 3;

    const [checkoutSuccess, setCheckoutSuccess] = useState(0);
    const isMounted = useRef(false);

    const handleClose = () => setModalShow(false);
    const handleShow = () => setModalShow(true);

    const radios = [
        { name: 'monthly', value: 'monthly' },
        { name: 'yearly', value: 'yearly' }
      ];

    const getApiServer = () => {
        if (WhichEnv === 'aws') {
            return 'https://api-us.turbosteed.com';
        }
        else {
            return 'https://192.168.1.215:5000';
        }
    }

    const loadScript = (src) => {
        return new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => {
            resolve(true);
          };
          script.onerror = () => {
            resolve(false);
          };
          document.body.appendChild(script);
        });
      };

    const openCheckout = async (sub_id) => {

        /*
        if (!TurboPaddleInstance) {
            Tdebug && console.log("no paddle instance!")
            return;
        }
            */

        // const sub = 'sub_Rwch25g4Kbj3hx';

        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

        if (!res || !sub_id) {
            alert("Razropay failed to load!!");
            return;
        }

        async function payNow(sub_id) {
      
            // Open Razorpay Checkout
            const options = {
              //key: 'YOUR_KEY_ID', // Replace with your Razorpay key_id
              name: 'Payment for TurboSteed',
              description: 'Payment for TurboSteed',
              //subscription_id: /*subsr*/ 'sub_Rw23451345234x',
              subscription_id: sub_id,
              "checkout_config_id" : "config_S09TDAkaAgZbIp",


              // Error handling
              "modal": {
                "ondismiss": function(){
                        console.log('Checkout form closed');
                    }
                },

                
                //handler: async(response)=>{}
                handler: (response) => {
                    console.log(response);
                    console.log('this is the response after the order is created');
                    console.log('i am in handler funtction after verify payment');
                    setCheckoutSuccess(CheckoutProcessing)
                    pollSubscriptionStatus();
                },
                
            };
      
            //const rzp = new Razorpay(options);
            //rzp.open();

            let rzInstance = null;
            try {

                //const razorpayInstance = new window.Razorpay(options);
                rzInstance = new window.Razorpay(options);

            }
            catch (e1) {
                console.log("Unable to open the payment gateway 25: " + e1);
                return;
            }

            try {
            
                console.log(rzInstance);
                console.log('this is razorpay instance value');
                
                // You can handle payment failure by listening to the failure event.
                rzInstance.on("payment.failed", async (response) => {
                    console.log("TS: Razorpay payment failed! ");
                    console.log(response.error.description);
                    //rzInstance.close();

                    // Test if pollSubscriptionStatus works.

                    setCheckoutSuccess(CheckoutFailed);
                });
                
                rzInstance.on("payment.success", async (response) => {
                    console.log("TS: Razorpay successful! Catch all event ");
                    console.log(response.error.description);
                    //rzInstance.close();

                    setCheckoutSuccess(CheckoutProcessing);
                    pollSubscriptionStatus();
                });

                rzInstance.open();
            }
            catch (re) {
                console.log("Error opening the payment gateway! " + re);
                //alert("Error opening the payment gateway"); 
                rzInstance.close();           
            }
        }

        payNow(sub_id);
        
    }

    async function HandleSubscribe(plan) {
      console.log("Subscribe Plan selected: ", plan);
      try {
        const response = await callApi(
          "/subscription",
          "PUT",
          {},
          JSON.stringify({
            planId: plan,
            tenure: tenure,
          })
        );

        console.log("Response of Subscription: ", response?.httpStatus);
        if (response?.httpStatus === "200") {
          console.log(
            "Subscription Api response: ",
            response?.respBody?.message?.payFor
          );
          openCheckout(response?.respBody?.message?.payFor);
        }else{
            handleShow()
        }
      } catch (error) {
        console.log("Subscribe Error", error);
      }
    }

    const pollSubscriptionStatus = async () => {
        Tdebug && console.log("Now going into polling mode...");

        const maxRetries = 5;
        let attempt = 0;
        let paymentSuccess = false;

        while ((attempt < maxRetries) && (paymentSuccess == false)) {
            try {
                const rcJson = await callApi('/ud', 'GET', {}, {});
                Tdebug && console.log(rcJson);

                if (rcJson.disposition == 'logout') {
                    Tdebug && console.log("Now logging out");
                    logOut();
                }

                if (rcJson.httpStatus != 200) {
                    if (rcJson.disposition == 'retry') {
                        Tdebug && console.log(rcJson.message);
                        if (attempt == maxRetries - 1) {
                            setError('Something went wrong, please contact support.');
                            setCheckoutSuccess(CheckoutFailed);
                        }
                    }
                    else if (rcJson.disposition == 'abort') {
                        Tdebug && console.log(rcJson.message);
                        if (attempt == maxRetries - 1) {
                            setError('Something went wrong, please contact support.');
                            setCheckoutSuccess(CheckoutFailed);
                        }
                    }
                    else if (rcJson.disposition == 'empty') {
                        Tdebug && console.log(rcJson.message);
                        Tdebug && console.log(rcJson);
                        setSubReceived('');
                        setAllPlans(rcJson.respBody.curPlans);
                        setPc(rcJson.respBody.pc);

                        if (attempt == maxRetries - 1) {
                            setError('Something went wrong, please contact support');
                            setCheckoutSuccess(CheckoutFailed);
                        }
                    }
                    else {
                        if (attempt == maxRetries - 1) {
                            setError('Something went wrong, please contact support');
                            setCheckoutSuccess(CheckoutFailed);
                        }
                    }

                    if (rcJson.respBody.etac) {
                        loginAction(null, rcJson.etac);
                    }
                }
                else {
                    if (rcJson.respBody.etac) {
                        loginAction(null, rcJson.etac);
                    }

                    Tdebug && console.log("Setting values");

                    const planId = rcJson.respBody.planId;
                    const planName = rcJson.respBody.plan;

                    console.log(planName);

                    // subReceived is the original plan that was set prior to upgrade/downgrde.
                    if(planName == subReceived){
                        paymentSuccess = false;
                    }
                    else {

                        setSubReceived(planName);
                        //setAllPlans(rcJson.respBody.curPlans);

                        const activeTerm = rcJson.respBody.planTerm || 'monthly';
                        setPlanTerm(activeTerm);
                        setTenure(activeTerm);

                        setLoading(false);

                        //Tdebug && console.log(rcJson.respBody.pc);
                        //setPc(rcJson.respBody.pc);

                        paymentSuccess = true;
                        
                    }
                }
            } catch (error) {
                setError('Something went wrong, please contact support');
                Tdebug && console.error('Error checking subscription status:', error);
                setCheckoutSuccess(CheckoutFailed);
                break;
            }

            attempt++;

            if (!paymentSuccess) {
                await new Promise(resolve => setTimeout(resolve, 5000));
            }
        }

        if (paymentSuccess) {
            navigate('/upgrade', { replace: true });
        }
    }

    useEffect(() => {

        /*
        initializePaddle({
            environment: 'sandbox',
            token: 'test_1c616ca85b0556c9e3372504fc2',
            eventCallback: function (data) {
                Tdebug && console.log(data);
                switch (data.name) {
                    case 'checkout.customer.created':
                    case 'checkout.loaded':
                    case 'checkout.customer.updated':
                    case 'checkout.payment.initiated':
                    case 'checkout.payment.selected':
                        break;

                    case 'checkout.completed':
                        Tdebug && console.log(
                            "Checkout is now complete, waiting for the window to close..."
                        )
                        setCheckoutSuccess(CheckoutProcessing);
                        pollSubscriptionStatus();
                        break;

                    case 'checkout.closed':
                        if (checkoutSuccess == CheckoutProcessing) {
                            Tdebug && console.log("Now polling for subscription status...");
                        }
                        break;
                    default:
                        setCheckoutSuccess(CheckoutFailed);
                        break;
                }
            }
        }).then(
            (paddleInstance) => {
                Tdebug && console.log("Paddle initialized!")
                Tdebug && console.log(paddleInstance);

                if (paddleInstance) {
                    setTurboPaddleInstance(paddleInstance);
                }
            },
        ).catch((err) => {
            console.log("Unable to initialize paddle");
            console.log(err);
        });

        */

        if (isMounted.current == false) {
            isMounted.current = true;
        }
        else {
            return;
        }

        const fetchData = async () => {

            // TEMP CODE
            setAllPlans(CurPricing);
            //setLoading(false);
            
            //return;

            const rcJson = await callApi('/ud', 'GET', {}, {});
            Tdebug && console.log(rcJson);

            if (rcJson.disposition == 'logout') {
                Tdebug && console.log("Now logging out");
                logOut();
            }

            if (rcJson.httpStatus != 200) {
                if (rcJson.disposition == 'retry') {
                    Tdebug && console.log(rcJson.message);
                    setError('Something went wrong, please retry...')
                }
                else if (rcJson.disposition == 'abort') {
                    Tdebug && console.log(rcJson.message);
                    setError('Something went wrong.')
                }
                else if (rcJson.disposition == 'empty') {
                    Tdebug && console.log(rcJson.message);
                    Tdebug && console.log(rcJson);
                    setSubReceived('');
                    //setAllPlans(rcJson.respBody.curPlans);
                    //setPc(rcJson.respBody.pc);
                }

                setLoading(false);

                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }
            }
            else {
                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }

                Tdebug && console.log("Setting values");

                localStorage.setItem('uDet', JSON.stringify(rcJson.respBody));

                const planName = rcJson.respBody.plan;
                const planId = rcJson.respBody.planId;

                Tdebug && console.log(rcJson);
                Tdebug && console.log(planName);
                Tdebug && console.log(planId);

                setSubReceived(planName);
                //setAllPlans(rcJson.respBody.curPlans);
                //setPc(rcJson.respBody.pc);

                const activeTerm = rcJson.respBody.planTerm || 'monthly';
                setPlanTerm(activeTerm);
                setTenure(activeTerm);

                setLoading(false);
            }
        }

        fetchData();
    }, []);

    useEffect(() => {
        Tdebug && console.log("Checkout completed, status is: " + checkoutSuccess);
    }, [checkoutSuccess]);

    useEffect(() => {
        Tdebug && console.log("Tenure changed: " + tenure);
    }, [tenure]);

    Tdebug && console.log(allPlans);
    Tdebug && console.log(loading);
    Tdebug && console.log(error);
    Tdebug && console.log(checkoutSuccess);

    // let buttons = {};
    const CurrentPlan = 0;
    const UpgradePlan = 1;
    const ContactUs = 2;

    /*
    if ((subReceived == '') || (subReceived == 'Free')) {
        buttons["Free Plan"] = CurrentPlan;
        buttons["Basic Plan"] = UpgradePlan;
        buttons["Creator Plan"] = ContactUs;
    } else if (subReceived == 'Basic') {
        buttons["Free Plan"] = ContactUs;
        buttons["Basic Plan"] = CurrentPlan;
        buttons["Creator Plan"] = ContactUs;
    }
    else {
        buttons["Free Plan"] = ContactUs;
        buttons["Basic Plan"] = ContactUs;
        buttons["Creator Plan"] = CurrentPlan;
    }
        */

    //Tdebug && console.log(buttons);
    if (loading) {
        return (
            <div className="app-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <Spinner animation="border" style={{ width: '2rem', height: '2rem', color: 'var(--accent-primary)' }} />
                    <div style={{ marginTop: '12px', fontSize: '13px', color: 'var(--text-tertiary)' }}>Loading...</div>
                </div>
            </div>
        );
    }

    if (checkoutSuccess === CheckoutProcessing) {
        return (
            <div className="app-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <Spinner animation="border" style={{ width: '2rem', height: '2rem', color: 'var(--accent-primary)' }} />
                    <div style={{ marginTop: '12px', fontSize: '13px', color: 'var(--text-tertiary)' }}>Confirming your payment...</div>
                </div>
            </div>
        );
    }

    const planShow = tenure === 'monthly' ? 'pricingMonthly' : 'pricingYearly';

    return (
        <div className="app-content animate-in">
            {/* Header */}
            <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px' }}>
                <div>
                    <h1 className="dashboard-title">Subscription</h1>
                    <p className="dashboard-subtitle">Choose the perfect plan for your website needs</p>
                </div>
                <span style={{
                    display: 'inline-flex', alignItems: 'center', padding: '4px 12px',
                    borderRadius: '100px', background: 'var(--success-soft)', color: 'var(--success)',
                    fontSize: '12px', fontWeight: 600,
                }}>
                    Current: {subReceived && subReceived.length ? subReceived : 'Free Plan'}
                </span>
            </div>

            {/* Payment failed banner */}
            {checkoutSuccess === CheckoutFailed && (
                <div style={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    background: 'var(--error-soft)', border: '1px solid rgba(239,68,68,0.2)',
                    borderRadius: 'var(--radius-md)', padding: '12px 16px', marginBottom: '24px',
                    fontSize: '13px', color: 'var(--text-primary)',
                }}>
                    <FiAlertTriangle size={16} style={{ color: 'var(--error)', flexShrink: 0 }} />
                    <strong>Payment Failed:</strong>&nbsp;Something went wrong. Please try again.
                </div>
            )}

            {/* Billing toggle */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '28px' }}>
                <div style={{ display: 'flex', background: 'var(--bg-tertiary)', borderRadius: 'var(--radius-md)', padding: '4px' }}>
                    {radios.map((radio) => (
                        <button
                            key={radio.value}
                            onClick={() => setTenure(radio.value)}
                            style={{
                                padding: '8px 20px', border: 'none', cursor: 'pointer', fontFamily: 'inherit',
                                borderRadius: 'var(--radius-sm)', fontSize: '13px', fontWeight: 500,
                                background: tenure === radio.value ? 'var(--bg-secondary)' : 'transparent',
                                color: tenure === radio.value ? 'var(--text-primary)' : 'var(--text-tertiary)',
                                boxShadow: tenure === radio.value ? 'var(--shadow-sm)' : 'none',
                                transition: 'all 150ms ease',
                            }}
                        >
                            {radio.name.charAt(0).toUpperCase() + radio.name.slice(1)}
                            {radio.value === 'yearly' && (
                                <span style={{ marginLeft: '6px', fontSize: '10px', padding: '2px 6px', background: 'var(--success-soft)', color: 'var(--success)', borderRadius: '100px' }}>
                                    Save 20%
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* Plan cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
                {allPlans[planShow] && allPlans[planShow].length ? allPlans[planShow].map((planDetails, key1) => {
                    const isFree = planDetails.plan === 'Free Plan';
                    const isPlanMatch = (subReceived === '' && isFree) ||
                        (subReceived === planDetails.plan) ||
                        (subReceived + ' Plan' === planDetails.plan);
                    const isCurrentPlan = isPlanMatch && (isFree || tenure === planTerm);
                    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    const isIndia = userTimeZone === 'Asia/Kolkata' || userTimeZone === 'Asia/Calcutta';
                    const priceString = isIndia ? planDetails.price['inr'] : planDetails.price['usd'];
                    const currencySymbol = isIndia ? '₹' : '$';
                    const priceMatch = priceString.match(/\d+(\.\d+)?/);
                    const priceValue = priceMatch ? parseFloat(priceMatch[0]) : 0;
                    const mainPrice = priceString === 'Custom' ? 'Custom' : `${currencySymbol}${priceValue}`;

                    return (
                        <div
                            key={key1}
                            className="bento-card"
                            style={{
                                display: 'flex', flexDirection: 'column', position: 'relative',
                                overflow: 'visible',
                                marginTop: isCurrentPlan ? '12px' : 0,
                                border: isCurrentPlan ? '2px solid var(--accent-primary)' : undefined,
                            }}
                        >
                            {isCurrentPlan && (
                                <div style={{
                                    position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)',
                                    background: 'var(--accent-primary)', color: 'white',
                                    fontSize: '11px', fontWeight: 600, padding: '3px 12px', borderRadius: '100px',
                                    whiteSpace: 'nowrap',
                                }}>
                                    Current Plan
                                </div>
                            )}

                            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>{planDetails.plan}</h3>
                                <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: '4px' }}>
                                    <span style={{ fontSize: '32px', fontWeight: 700, letterSpacing: '-1px' }}>{mainPrice}</span>
                                    {priceString !== 'Custom' && priceValue > 0 && (
                                        <span style={{ fontSize: '13px', color: 'var(--text-tertiary)' }}>/{tenure === 'yearly' ? 'mo' : 'month'}</span>
                                    )}
                                </div>
                            </div>

                            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px', flex: 1 }}>
                                {planDetails.planFeatures.map((featLine, key2) => (
                                    <li key={key2} style={{
                                        display: 'flex', alignItems: 'flex-start', gap: '10px',
                                        padding: '7px 0', fontSize: '13px', color: 'var(--text-secondary)',
                                        borderBottom: key2 < planDetails.planFeatures.length - 1 ? '1px solid var(--border-subtle)' : 'none',
                                    }}>
                                        <FiCheck size={14} style={{ color: 'var(--success)', flexShrink: 0, marginTop: '2px' }} />
                                        {featLine}
                                    </li>
                                ))}
                            </ul>

                            {isCurrentPlan ? (
                                <button disabled style={{
                                    width: '100%', padding: '10px', border: '1px solid var(--border-color)',
                                    borderRadius: 'var(--radius-md)', background: 'var(--bg-tertiary)',
                                    color: 'var(--text-tertiary)', fontSize: '13px', fontWeight: 500,
                                    cursor: 'not-allowed', fontFamily: 'inherit',
                                }}>
                                    Current Plan
                                </button>
                            ) : (
                                <button
                                    onClick={(priceString === 'Custom' || !isIndia)
                                        ? () => window.location.href = 'mailto:support@turbosteed.com'
                                        : () => HandleSubscribe(planDetails?.plan)}
                                    style={{
                                        width: '100%', padding: '10px', border: 'none',
                                        borderRadius: 'var(--radius-md)', background: 'var(--accent-gradient)',
                                        color: 'white', fontSize: '13px', fontWeight: 500,
                                        cursor: 'pointer', fontFamily: 'inherit',
                                    }}
                                >
                                    {(priceString === 'Custom' || !isIndia) ? 'Contact Us' : 'Subscribe'}
                                </button>
                            )}
                        </div>
                    );
                }) : null}
            </div>

            {/* Error modal */}
            <Modal show={showModal} onHide={handleClose} centered dialogClassName="modern-modal">
                <Modal.Header closeButton>
                    <Modal.Title style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ width: '28px', height: '28px', borderRadius: 'var(--radius-md)', background: 'var(--error-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--error)' }}>
                            <FiAlertTriangle size={14} />
                        </div>
                        Error
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: '14px' }}>
                    Something went wrong. Please contact support at{' '}
                    <a href="mailto:support@turbosteed.com" style={{ color: 'var(--accent-primary)' }}>support@turbosteed.com</a>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default StSubscription;
